import { defineAsyncComponent, markRaw } from "vue";
import type { TileConfigType } from "@/modules/tiles/tileConfigs";

export const tileConfigs: TileConfigType = {
  QualityParetoTile: {
    active: true,
    settingsModule: markRaw(
      defineAsyncComponent(
        () => import("@/modules/tiles/components/qualityParetoTile/QualityParetoTileSettings.vue"),
      ),
    ),
    component: markRaw(
      defineAsyncComponent(
        () => import("@/modules/tiles/components/qualityParetoTile/QualityParetoTile.vue"),
      ),
    ),
    icon: "fa-solid fa-yin-yang",
  },
};
